import Vue from 'vue';
import { formatDisplayDate } from '~/utils/dateDisplay';

export default (_context, inject) => {
  inject('displayDate', formatDisplayDate);
  Vue.filter('displayDate', formatDisplayDate);
};